import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import { Box, Chip, MenuItem, Select, Stack, Tooltip, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AutoSuggestion from "../../components/autocomplete";
import DateRangePickerComponent from "../../components/date/DateRangePickerComponent";
import CommonModel from '../../components/dialog/Common';
import useDebounce from "../../hooks/use.debounce";
import { capitalizeFirstLetter, getFormatedDate, getRedirectlink, parseJSONorString, uniqueArrayByKey } from '../../utils/common';
import { getAdminUserListing, getAllAuditListing, getCampaignAndinfluencersData } from './action';
import { updateAudit } from './auditSlice';
import PieChartWithPercentage from "./graph";
import { CUSTOM_PAPER_COMPONENT_FOR_AUTO_SUGGEST, CustomSearchInput, FORM_INPUTFIELD_STYLES, FORM_SELECTFIELD_STYLES, START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT, TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES } from "../../utils/constant";
import CustomPagination from "../../utils/CustomPagination";
import DeleteIcon from "../../assets/images/icons/X.svg";
function EnhancedTableHead(props) {
    const { order, orderBy } = props;
    const headCells = [
        {
            id: "name",
            numeric: false,
            disablePadding: true,
            label: "User Name",
            type: "",
        },
        {
            id: "recort_type",
            numeric: false,
            disablePadding: true,
            label: "Record Type",
            type: "",
        },
        {
            id: "Record",
            numeric: false,
            disablePadding: true,
            label: "Record Name",
            type: "",
        },
        {
            id: "Field Name",
            numeric: false,
            disablePadding: true,
            label: "Field Name",
            type: "",
        },

        {
            id: "Time Stamp",
            numeric: false,
            disablePadding: true,
            label: "Time Stamp",
            type: "",
        },
        {
            id: "action",
            numeric: false,
            disablePadding: true,
            label: "Action",
            type: "",
        },
    ];

    return (
        <TableHead className="hideActionSort">
            <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
                {headCells.map((headCell) => {
                    return (
                        <TableCell
                            key={headCell?.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                IconComponent={() => null}>
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}


const AuditTrails = () => {
    const dispatch = useDispatch();
    const [modelOpen, setModelOpen] = useState(false);
    const [jsonData, setJsonData] = useState('');
    const {
        graphData,
        limit,
        page,
        sort_key,
        totalPages,
        listing,
        totalCount,
        filters,
        userListing,
        removeUsers
    } = useSelector((state) => state.auditSlice);
    const {
        triggerTable
    } = useSelector((state) => state.commonSlice)
    const debouncedSearch = useDebounce(filters.search, 500);
    useEffect(() => {
        dispatch(getAdminUserListing());
        dispatch(getCampaignAndinfluencersData());
        dispatch(getAllAuditListing());
    }, [])
    const handleChange = (value) => {
        dispatch(updateAudit({ page: value - 1 }));
        dispatch(getAllAuditListing());
    };
    const handleSearch = (event) => {
        if (event.target.value) {
            dispatch(updateAudit({ filters: { ...filters, search: event.target.value }, page: 0 }));
        } else {
            dispatch(updateAudit({ filters: { ...filters, search: "" }, page: 0 }));
            dispatch(getAllAuditListing());
        }

    };

    const handleSearchClear = () => {
        dispatch(updateAudit({ filters: { ...filters, search: "" } }));
        dispatch(getAllAuditListing());
    };
        const handleChangePerPage = (event, value) => {
        dispatch(updateAudit({ limit: event.target.value, page: 0 }));
        dispatch(getAllAuditListing());
    };
    useEffect(() => {
        if (debouncedSearch)
            dispatch(getAllAuditListing())
    }, [debouncedSearch, dispatch]);

    const Details = () => {
        return <TableContainer stickyHeader >
            <Table stickyHeader aria-label="simple table">
                <TableHead>
                    <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
                        <TableCell align="left">Field Name</TableCell>
                        <TableCell align="left">Old Value</TableCell>
                        <TableCell align="left">New Value</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow sx={TABLE_BODY_ROW_MUI_STYLES}>
                        <TableCell align="left" className="capitalize-first-letter">
                            {jsonData?.fieldName || "N/A"}
                        </TableCell>

                        <TableCell align="left" >
                            {/* <span dangerouslySetInnerHTML={{ __html: jsonData?.oldValue || "N/A" }} ></span> */}
                            {typeof parseJSONorString(jsonData?.oldValue) == "object" ? <ul>
                                {Object.entries(parseJSONorString(jsonData?.oldValue||"{}")).map(([key, value]) => (
                                    value?.length > 0 && value && <li key={key}>
                                        {capitalizeFirstLetter(key)}: {value || "N/A"}
                                    </li>
                                ))}
                            </ul> : <span dangerouslySetInnerHTML={{ __html: jsonData?.oldValue || "N/A" }} ></span>}</TableCell>
                        <TableCell align="left">
                            {typeof parseJSONorString(jsonData?.newValue) == "object" ? <ul>
                                {Object.entries(parseJSONorString(jsonData?.newValue)).map(([key, value]) => (
                                    value?.length > 0 && value && <li key={key}>
                                        {capitalizeFirstLetter(key)}: {Array.isArray(value) ? value.toString() : value || "N/A"}
                                    </li>
                                ))}
                            </ul> : <span dangerouslySetInnerHTML={{ __html: jsonData?.newValue || "N/A" }} ></span>}

                        </TableCell>
                    </TableRow>

                </TableBody>
            </Table>
        </TableContainer>
    }
    return <>
        <Stack direction="row" alignItems="center" mb={2}>
            <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{
                    minHeight: '42px', paddingX: '16px'
                }}
            >
                <Typography variant="h1" className="page-title">
                    Audit Trails
                </Typography>
            </Stack>
        </Stack>

        <Stack direction={{ lg: "row", xs: 'column' }} justifyContent="" alignItems="center" gap={4} sx={{ border: '0px solid red', width: '100%', px: 4 }}>
            <Box sx={{
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)',
                borderRadius: '10px',
                width: { lg: '50%', xs: '100%' }, py: 3
            }}>
                <Typography variant="h4" px={3} pb={2} className="page-title">Campaigns Status</Typography>
                <PieChartWithPercentage type={1} data={graphData?.campaign} />
            </Box>
            <Box sx={{
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)',
                borderRadius: '10px', width: { lg: '50%', xs: '100%' }, py: 3
            }}>
                <Typography variant="h4" px={3} pb={2} className="page-title">Influencers Status</Typography>
                <PieChartWithPercentage type={2} data={graphData?.influencer} />
            </Box>
        </Stack>


        <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            flexWrap="wrap" gap={2}
            sx={{
                minHeight: '42px', paddingX: '16px', py: 4
            }}
        >
            <Typography className="page-title" variant="h1">Activity Logs</Typography>
            <Stack direction="row" justifyContent="flex-end" alignItems="center" flexWrap="wrap" gap={2}>
                <CustomSearchInput
                    className="inputSearch sContrl p-0"
                    value={filters.search}
                    placeholder={"Search here..."}
                    handleSearch={handleSearch}
                    clearSearch={handleSearchClear}
                    startAdornment={START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT}
                />
                <AutoSuggestion
                    sx={{ ...FORM_SELECTFIELD_STYLES, maxWidth: '350px', width: '350px' }}
                    CustomPaperComponent={CUSTOM_PAPER_COMPONENT_FOR_AUTO_SUGGEST}
                    multiple={true}
                    key={removeUsers}
                    disableClearable={true}
                    values={filters.userId || []}
                    className="auto-chips-cover"
                    label={""}
                    limitTags={1}
                    onChange={(_e, newValue) => {
                        dispatch(updateAudit({ filters: { ...filters, userId: newValue?.map((v) => v.id), userIds: newValue?.map((v) => v.id)?.toString() } }));
                        dispatch(getAllAuditListing());
                    }}
                    placeholder="All Users"
                    defaultValue={filters.userId || []}
                    id={`users-${filters.userId?.length}`}
                    onModalClose={() => { }}
                    size="small"
                    name="userId"
                    options={userListing}
                    isOptionEqualToValue={(option, value) => {
                        if (
                            value === "" ||
                            option === "" ||
                            value === option
                        )
                            return option;
                    }}
                    getOptionLabel={(option) =>
                        option.adminName
                    }
                    renderTags={(value, getTagProps) => {
                        if (!Array.isArray(value)) return null;
                        return value.map((option, index) => {
                            return (
                                <Chip
                                    key={option.option || option}
                                    label={<Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'white' }}>
                                        {option.adminName?.substring(0, 10) || option}
                                    </Typography>}
                                    {...getTagProps({ index })}
                                    sx={{
                                        background: 'black !important',
                                        borderRadius: '62px', border: '0px solid #CCCBCB',
                                        padding: "3px 8px", height: '32px'
                                    }}
                                    deleteIcon={<img src={DeleteIcon} style={{ filter: 'brightness(0) invert(1)', }} alt="delete icon" width={24} height={24} />} // Custom delete icon
                                />
                            )
                        })
                    }
                    }


                    renderOption={(props, option) => {
                        return (
                            <>
                                <li {...props} style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap', padding: '2px 8px', width: '100%', borderRadius: '0px', border: '0px solid #CCCBCB', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', gap: 2
                                }}><Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#444141', }}>{option.adminName}</Typography></li>
                            </>)
                    }}
                />
                <DateRangePickerComponent text="Select Date" monthsShown={1} getSelectedDate={(dates) => {

                    if (dates?.filter((v) => v)?.length === 2) {
                        dispatch(updateAudit({ filters: { ...filters, startDate: getFormatedDate(dates[0]), endDate: getFormatedDate(dates[1]) } }));
                        dispatch(getAllAuditListing());
                    }

                }} dateReset={filters} style={{ ...FORM_INPUTFIELD_STYLES }} />
                <Select
                    sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '300px', width: '300px' }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                borderRadius: "8px",
                                mt: 1,
                            },
                        },
                    }}
                    value={filters.tableName || ''}
                    name="tableName"
                    onChange={(e) => {
                        dispatch(updateAudit({ filters: { ...filters, tableName: e.target.value } }));
                        dispatch(getAllAuditListing());
                    }}
                    displayEmpty
                    defaultValue={""}
                >
                    <MenuItem value="" disabled hidden>
                        All Records
                    </MenuItem>

                    <MenuItem value=" " >
                        All Records (All)
                    </MenuItem>


                    {uniqueArrayByKey(triggerTable, "tableName")?.map((row) => (
                        <MenuItem className="capitalize-first-letter" key={row.tableName} value={row.tableName}>
                            {capitalizeFirstLetter(row?.tableName)}
                        </MenuItem>
                    ))}
                </Select>
                <Tooltip title="Refresh listing">
                    <RotateLeftIcon toolTip="Refresh page" size="small" sx={{ cursor: "pointer", color: '#6C7692', mt: 1.5 }}
                        onClick={() => {
                            dispatch(updateAudit({ filters: {}, removeUsers: Math.random() }))
                            dispatch(getAllAuditListing());
                        }}
                    />
                </Tooltip>
            </Stack>
        </Stack>
        <Box
            sx={{
                backgroundColor: '#fff',
                transition: 'all .5s ease-in-out',
                position: 'relative',
            }}>
            <TableContainer>
                <Table aria-label="simple table">
                    <EnhancedTableHead
                        order={"test"}
                        orderBy={sort_key}
                        onRequestSort={() => { }}
                        numSelected={0}
                        onSelectAllClick={function (

                        ) {
                            throw new Error("Function not implemented.");
                        }}
                    />

                    <TableBody>
                        {listing?.length > 0 ? (
                            listing?.map((row) => {
                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row?.id}
                                        sx={TABLE_BODY_ROW_MUI_STYLES}>
                                        <TableCell component="td" scope="row" >
                                            {row?.name}
                                        </TableCell>

                                        <TableCell component="td" align="left" className="capitalize-first-letter">
                                            {row?.table}
                                        </TableCell>

                                        <TableCell component="td" align="left" > <Link onClick={(e) => {
                                            e.preventDefault();
                                            window.open(getRedirectlink(row?.table, row.recordId, row.userId), "_blank")
                                        }}>{row.recordName}</Link></TableCell>
                                        <TableCell component="td" align="left" className="capitalize-first-letter">{row.fieldName || "N/A"}</TableCell>
                                        <TableCell component="td" align="left">{getFormatedDate(row.createdDate, 'DD MMMM YYYY hh:mm A')}</TableCell>
                                        <TableCell component="td" align="left"> <span className="viewIcon" onClick={() => {
                                            setJsonData(row)
                                            setModelOpen(true);
                                        }}>
                                            View Changes
                                        </span></TableCell>
                                    </TableRow>

                                )
                            })) : (
                            <TableRow colSpan={10}>
                                <TableCell colSpan={10} style={{ textAlign: 'center' }}>

                                    <Typography
                                        color="inherit"
                                        variant="subtitle1"
                                        alignItems={"center"}
                                        component="h3"
                                    >
                                        No Data found!
                                    </Typography>

                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>

            </TableContainer>
            <Stack
                sx={{
                    background: 'transparent',
                    height: '60px',
                    border: '1px solid #E9EAEB'
                }}
                direction="row"
                alignItems={"center"}
                justifyContent={"flex-end"}>
                <CustomPagination
                    count={Math.ceil(totalPages / limit) || 0}
                    onChange={handleChange}
                    currentPage={page}
                    handleChangePerPage={handleChangePerPage}
                    limit={limit}
                    listingCount={listing?.length}
                    totalCount={totalCount}
                    defaultPage={1} siblingCount={1} boundaryCount={1} />
            </Stack>
        </Box>

        <CommonModel
            flag={true}
            open={modelOpen}
            handleDialogClose={() => setModelOpen(false)}
            dialogTitle={"Values"}
            dialogPara={<Details />}
            nvCancel={""}
            yesHandle={() => {
                setModelOpen(false)
            }}
        />
    </>
}
export default AuditTrails;